import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UISelect from 'UIComponents/input/UISelect';
import { getFallbackRoutingTypeOptions } from '../constants/RoutingRulesSelectOptions';
import { getFallback, getRotationMethod, getType } from '../operators/routingRulesGetters';
import { setFallback } from '../operators/routingRulesSetters';
import { buildRoutingRulesFromType } from '../utils/buildRoutingRulesFromType';
import { RoutingMethodTooltip } from './RoutingMethodTooltip';
import RuleBox from './RuleBox';
import { AI_CHATBOT, OWNER } from '../constants/RoutingTypes';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import { getUsersSeatsUrl } from '../../urls/getUsersSeatsUrl';
import UILink from 'UIComponents/link/UILink';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const getFallbackTitle = routingRules => {
  const type = getType(routingRules);
  switch (type) {
    case AI_CHATBOT:
      return /*#__PURE__*/_jsx(FormattedHTMLMessage, {
        message: "routing-ui.routingRules.fallback.aiChatbotLabel"
      });
    case OWNER:
    default:
      return /*#__PURE__*/_jsx(FormattedHTMLMessage, {
        message: "routing-ui.routingRules.fallback.label"
      });
  }
};
const getFallbackTooltip = (routingRules, isUngatedForHelpDeskRoutingScopeFiltering) => {
  const type = getType(routingRules);
  switch (type) {
    case AI_CHATBOT:
      return /*#__PURE__*/_jsx("p", {
        className: "m-bottom-0",
        children: /*#__PURE__*/_jsx(RoutingMethodTooltip, {
          routingRules: routingRules
        })
      });
    case OWNER:
    default:
      return isUngatedForHelpDeskRoutingScopeFiltering ? /*#__PURE__*/_jsx(FormattedJSXMessage, {
        message: "routing-ui.routingRules.fallback.tooltip.onlyAssignsWhenNoServiceSeat_jsx",
        elements: {
          UILink
        },
        options: {
          external: true,
          href: getUsersSeatsUrl()
        }
      }) : /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsx("p", {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "routing-ui.routingRules.fallback.tooltip.onlyAssignsWhen"
          })
        }), /*#__PURE__*/_jsx("p", {
          className: "m-bottom-0",
          children: /*#__PURE__*/_jsx(RoutingMethodTooltip, {
            routingRules: routingRules
          })
        })]
      });
  }
};
const FallbackRow = ({
  disabled,
  routingRules,
  onRuleUpdate,
  FormControl,
  hasRoutingAccess,
  isUngatedForHelpDeskRoutingScopeFiltering
}) => {
  const fallback = getFallback(routingRules);
  const rotationMethod = getRotationMethod(routingRules) || undefined;
  const onFallbackTypeChange = evt => {
    onRuleUpdate(setFallback(buildRoutingRulesFromType(evt.target.value, {
      rotationMethod
    }), routingRules));
  };
  return /*#__PURE__*/_jsx(RuleBox, {
    FormControl: FormControl,
    required: true,
    label: getFallbackTitle(routingRules),
    tooltip: getFallbackTooltip(routingRules, isUngatedForHelpDeskRoutingScopeFiltering),
    tooltipProps: {
      maxWidth: 287
    },
    children: /*#__PURE__*/_jsx(UISelect, {
      defaultOpen: false,
      disabled: disabled || !hasRoutingAccess,
      options: getFallbackRoutingTypeOptions(),
      searchable: false,
      value: getType(fallback),
      onChange: onFallbackTypeChange
    })
  });
};
FallbackRow.displayName = 'FallbackRow';
export default FallbackRow;